import classnames from 'classnames';
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import { getBlockClassNames } from '@components/class-dropdown';
import { DEFAULT_CSS_CLASS } from '@constants';

const Save = ({ attributes }) => {
  const { blockClassNames, blockVisibility } = attributes;
  const relatedPostClasses = getBlockClassNames(blockClassNames);
  const classes = classnames({
    disable: !blockVisibility,
  });
  const blockProps = useBlockProps.save({
    className: `${relatedPostClasses} ${classes} ${DEFAULT_CSS_CLASS.RELATED_POSTS}`,
  });

  return (
    <div {...blockProps}>
      <InnerBlocks.Content />
    </div>
  );
};

export default Save;
